import Modal from "components/common/controls/modal/Modal";
import { connect } from "react-redux";
import { RootState } from "store/store";
import ContactSalesForm from "./ContactSalesForm";

interface Props {
  userName?: string;
  userEmail?: string;
  userPhone?: string;
  userCompany?: string;
  productId: number;
  onClose: () => void;
}

export function ContactSalesPopup(props: Props) {
  const { userName, userEmail, userPhone,userCompany, productId, onClose } = props;

  return (
    <div>
      <Modal
        visible={true}
        height={"auto"}
        onClose={onClose}
        maxWidth="471px"
        title={"Contact sales"}
        displayDefaultActions={false}
      >
        <div className="mb-6">
          Please fill in the form below. You can expect a reply within two
          business days.
        </div>

        <ContactSalesForm
          userName={userName}
          userEmail={userEmail}
          userPhone={userPhone}
          userCompany={userCompany}
          onSuccess={onClose}
          onCancel={onClose}
          productId={productId}
        />
      </Modal>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    userName: state.userData.currentUserDetail?.fullName,
    userEmail: state.userData.currentUserDetail?.email,
    userPhone: state.userData.currentUserDetail?.phone,
    userCompany: state.userData.currentUserDetail?.companyName,
    ...props,
  };
};

export default connect(mapStateToProps)(ContactSalesPopup);
